<div class="card mb-4">
    <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <h3 class="card-title mb-0">Contacts</h3>
            <button class="btn btn-primary"
                *ifHasPermission="{ requiredPermissions: [PropertyPermission.Update], userPermissionOnly: false }"
                (click)="openAddMembersModal()">
                <fa-duotone-icon icon="user-plus" secondaryOpacity="0.9" class="me-1"></fa-duotone-icon>
                Attach Members
            </button>
        </div>

        <ms-add-members-to-property
            #addMembersRef
            [propertyId]="property()?.propertyId"
            (membersAddedToProperty)="onMembersAddedToProperty()">
        </ms-add-members-to-property>

        @if (!hasMembers()) {
        <p class="text-muted mb-0">No members are associated with this property.</p>
        } @else {

        <div class="row g-3">
            @for (member of owners(); track member.memberId) {
            <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                <div class="card h-100 border contact-card position-relative"
                    [class.contact-card-clickable]="canViewMember(member.memberId)">

                    <!-- Desktop kebab menu -->
                    <div class="dropdown position-absolute top-0 end-0 m-2 contact-card-menu"
                        *ifHasPermission="{ requiredPermissions: [PropertyPermission.Update], userPermissionOnly: false }">
                        <button type="button" class="btn btn-link text-secondary p-2 lh-1"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            <fa-duotone-icon icon="ellipsis-vertical" secondaryOpacity="0.9" size="lg" />
                        </button>
                        <ul class="dropdown-menu dropdown-menu-end">
                            <li>
                                <a class="dropdown-item" (click)="requestDetach(member)">
                                    <fa-duotone-icon icon="minus" secondaryOpacity="0.9" class="me-2" />
                                    Detach from Property
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div class="card-body d-flex flex-column align-items-center text-center py-4"
                        (click)="viewMember(member)">
                        <ms-avatar [identity]="toIdentity(member)" [avatarSize]="50" avatarShape="circle"
                            [showUploadControls]="false"></ms-avatar>
                        <span class="fw-semibold mt-3">{{ member.firstName }} {{ member.lastName }}</span>
                        <span class="badge bg-primary-subtle text-primary-emphasis mt-2">Owner</span>
                    </div>

                    <!-- Mobile actions dropdown -->
                    <button type="button" class="dropdown-toggle contact-card-mobile-action"
                        data-bs-toggle="dropdown"
                        *ifHasPermission="{ requiredPermissions: [PropertyPermission.Update], userPermissionOnly: false }">
                        Actions
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end contact-card-mobile-menu">
                        <li>
                            <a class="dropdown-item" (click)="requestDetach(member)">
                                <fa-duotone-icon icon="minus" secondaryOpacity="0.9" class="me-2" />
                                Detach from Property
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            }

            @for (member of tenants(); track member.memberId) {
            <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                <div class="card h-100 border contact-card position-relative"
                    [class.contact-card-clickable]="canViewMember(member.memberId)">

                    <!-- Desktop kebab menu -->
                    <div class="dropdown position-absolute top-0 end-0 m-2 contact-card-menu"
                        *ifHasPermission="{ requiredPermissions: [PropertyPermission.Update], userPermissionOnly: false }">
                        <button type="button" class="btn btn-link text-secondary p-2 lh-1"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            <fa-duotone-icon icon="ellipsis-vertical" secondaryOpacity="0.9" size="lg" />
                        </button>
                        <ul class="dropdown-menu dropdown-menu-end">
                            <li>
                                <a class="dropdown-item" (click)="requestDetach(member)">
                                    <fa-duotone-icon icon="minus" secondaryOpacity="0.9" class="me-2" />
                                    Detach from Property
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div class="card-body d-flex flex-column align-items-center text-center py-4"
                        (click)="viewMember(member)">
                        <ms-avatar [identity]="toIdentity(member)" [avatarSize]="50" avatarShape="circle"
                            [showUploadControls]="false"></ms-avatar>
                        <span class="fw-semibold mt-3">{{ member.firstName }} {{ member.lastName }}</span>
                        <span class="badge bg-secondary-subtle text-secondary-emphasis mt-2">Tenant</span>
                    </div>

                    <!-- Mobile actions dropdown -->
                    <button type="button" class="dropdown-toggle contact-card-mobile-action"
                        data-bs-toggle="dropdown"
                        *ifHasPermission="{ requiredPermissions: [PropertyPermission.Update], userPermissionOnly: false }">
                        Actions
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end contact-card-mobile-menu">
                        <li>
                            <a class="dropdown-item" (click)="requestDetach(member)">
                                <fa-duotone-icon icon="minus" secondaryOpacity="0.9" class="me-2" />
                                Detach from Property
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            }
        </div>

        }
    </div>
</div>

<ms-confirmation-modal
    #detachConfirmationModalRef
    modalId="detachMemberFromPropertyConfirmationModal"
    cancelButtonText="Cancel"
    [isSubmitting]="isSubmitting"
    (confirmed)="confirmDetach()"
    (cancelled)="cancelDetach()"
/>

<ms-info-modal
    #detachInfoModalRef
    modalId="detachMemberFromPropertyInfoModal"
    (onConfirm)="onDetachInfoConfirmed()"
/>